import { render, staticRenderFns } from "./PhoneDetailForm.vue?vue&type=template&id=5faa38ea&"
import script from "./PhoneDetailForm.vue?vue&type=script&lang=js&"
export * from "./PhoneDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports